module.exports = __webpack_public_path__ + "static/img/asideMenu.df3585fd.png";